interface InfoIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}
const InfoIcon: React.FC<InfoIconProps> = ({ width = 14, height = 15, color = "#595A61" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 14.2083C11.5899 14.2083 14.5 11.2981 14.5 7.70825C14.5 4.1184 11.5899 1.20825 8 1.20825C4.41015 1.20825 1.5 4.1184 1.5 7.70825C1.5 11.2981 4.41015 14.2083 8 14.2083Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.5 10.7083H9.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 10.7083V7.20825H7" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 4.95825C7.86193 4.95825 7.75 4.84632 7.75 4.70825C7.75 4.57018 7.86193 4.45825 8 4.45825"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4.95825C8.13807 4.95825 8.25 4.84632 8.25 4.70825C8.25 4.57018 8.13807 4.45825 8 4.45825"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
